import { inject, Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { from, map, mergeMap, Observable } from 'rxjs';

import { fetchAuthSession } from 'aws-amplify/auth';
import { ApplicationConfigService } from 'app/core/config/application-config.service';

@Injectable()
export class TravomateAuthInterceptor implements HttpInterceptor {
  private readonly applicationConfigService = inject(ApplicationConfigService);

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const serverApiUrl = this.applicationConfigService.getEndpointFor('');
    if (!request.url || (request.url.startsWith('http') && !(serverApiUrl && request.url.startsWith(serverApiUrl)))) {
      return next.handle(request);
    }

    return from(fetchAuthSession()).pipe(
      map(session => {
        if (session.tokens?.accessToken) {
          return request.clone({
            setHeaders: {
              Authorization: `Bearer ${session.tokens.accessToken.toString()}`,
            },
          });
        }
        return request;
      }),
      mergeMap(req => next.handle(req)),
    );
  }
}
